import React, { useEffect } from 'react';
import { SwipeableRow, CalculatorBottomBar } from '../../components';
import { IWoocommerceProduct, ProductType } from 'interfaces';
import { useNavigate, useLocation } from 'react-router-dom';
import { useWooCommerce, useWooCommerceActions } from '../../hooks/wooCommerce';
import { CircularProgress } from '@mui/material';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import styles from "./choose-product.module.scss";
import generateClass from '../../utils/generateClass';
const arrowBackIcon = require("../../assets/icons/arrow-back.svg").default;


export const ChooseProduct = () : JSX.Element => {
    const location = useLocation();
    const navigate = useNavigate();
    const handleNavigation = (pathname: string, state: any) => navigate(pathname, { state });

    const stylePrefix = 'package-building-';
    const locationState = location.state as { context?: { type?: ProductType } } | null;
    const typeFromContext: ProductType = locationState?.context?.type ?? ProductType.Kite;
    
    const { allProducts, loaded, loading, currentProductsByType } = useWooCommerce();
    const { loadAllVariationsForProductById } = useWooCommerceActions();

    const [currentGearTag, setCurrentGearTag] = React.useState('calc__latestGear');
    const handleGearToggle = (
      event: React.MouseEvent<HTMLElement>,
      gearTag: string,
    ) => {
        if(gearTag != null && gearTag != ''){
            setCurrentGearTag(gearTag);
        }
    };

    // pre-load product variations for selected product category
    useEffect(() => {
        if (!loading && loaded) {
            var products = currentProductsByType(typeFromContext) as IWoocommerceProduct[];
            products.forEach((value: IWoocommerceProduct) => {
                if (value.productVariations == null || value.productVariations.length === 0){
                    loadAllVariationsForProductById(value.id);
                }
            });
        }
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [loadAllVariationsForProductById, allProducts]);

    const calcTagPreSeason = 'calc__preSeasonGear';
    const filterProductsByGear = () => {
        let productsByType = currentProductsByType(typeFromContext) as IWoocommerceProduct[];
        return currentGearTag === calcTagPreSeason ? 
        productsByType.filter(product => product.tags.map(tag => tag.name).includes(calcTagPreSeason) === true) : 
        productsByType.filter(product => product.tags.map(tag => tag.name).includes(calcTagPreSeason) === false);
    };

    return (
        <>
            <img className={styles.arrowBackIcon} alt="" src={arrowBackIcon} style={{cursor: 'pointer'}} onClick={() => { handleNavigation("/chooseType", { context: { type: null } }) }} />

            <div className={generateClass(styles, stylePrefix, '-info-container')}>
            { (loading && !loaded) ? 
                <CircularProgress className={styles.centered} />
                : 
                <>
                { typeFromContext != null ? 
                    <div>
                        { (typeFromContext === ProductType.Kite) &&
                            <h4>Choose a kite</h4>
                        }
                        { (typeFromContext === ProductType.Board) &&
                            <h4>Choose a board</h4>
                        }
                        { (typeFromContext === ProductType.Bar) &&
                            <h4>Choose a bar</h4>
                        }
                        <div style={{margin: '10%', textAlign: 'center'}}>
                        <ToggleButtonGroup
                            color="primary"
                            value={currentGearTag}
                            exclusive
                            onChange={handleGearToggle}
                            aria-label="Gear tag"
                            
                            >
                            <ToggleButton 
                                value="calc__latestGear" 
                                sx={(theme) => ({ 
                                    borderWidth: currentGearTag === "calc__latestGear" ? '3px' : '', 
                                    borderColor: currentGearTag === "calc__latestGear" ? theme.palette.primary.main : '' })}>Latest Gear</ToggleButton>
                            <ToggleButton 
                                value="calc__preSeasonGear"
                                sx={(theme) => ({ 
                                    borderWidth: currentGearTag === "calc__preSeasonGear" ? '3px!important' : '1px', 
                                    borderColor: currentGearTag === "calc__preSeasonGear" ? theme.palette.primary.main : '' })}>Pre-Season Gear</ToggleButton>
                        </ToggleButtonGroup>
                        </div>
                        <SwipeableRow currentProducts={filterProductsByGear()} />
                    </div>
                    : <></>
                }
                </>
            }
            </div>
            <CalculatorBottomBar allProducts={[]} selectedProduct={undefined} isProductInQuiver={false} />
        </>
    );
};
